import { styled, Container, Box, useTheme } from '@mui/material';
import { useSelector } from 'react-redux';
import { Outlet, redirect, useNavigate } from 'react-router-dom';

import Header from './vertical/header/Header';
import HorizontalHeader from '../full/horizontal/header/Header';
import Sidebar from './vertical/sidebar/Sidebar';
import Customizer from './shared/customizer/Customizer';
import Navigation from './horizontal/navbar/Navbar';
import { useEffect } from 'react';

const MainWrapper = styled('div')(() => ({
  display: 'flex',
  minHeight: '100vh',
  width: '100%',
}));

const PageWrapper = styled('div')(({ theme }) => ({
  display: 'flex',
  flexGrow: 1,
  paddingBottom: '60px',
  flexDirection: 'column',
  zIndex: 1,
  width: '100%',
  backgroundColor: 'transparent',
  transition: theme.transitions.create('margin', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
}));

const FullLayout = () => {
  const customizer = useSelector((state) => state.customizer);
  const theme = useTheme();
  const pathname = window.location.pathname;
  const navigate = useNavigate();

  // useEffect(() =>{
  //   if(pathname === '/'){
  //     navigate('/dashboard');
  //   }
  // }, [pathname]);

  return (
    <MainWrapper
      className={customizer.activeMode === 'dark' ? 'darkbg mainwrapper' : 'mainwrapper'}
      dir={customizer.activeDir}
    >
      {/* Sidebar */}
      {customizer.isHorizontal ? '' : <Sidebar />}
      
      {/* Main Wrapper */}
      <PageWrapper
        className="page-wrapper"
        sx={{
          ...(customizer.isCollapse && !customizer.isSidebarHover && {
            [theme.breakpoints.up('lg')]: { 
              ml: `${customizer.MiniSidebarWidth}px`,
              width: `calc(100% - ${customizer.MiniSidebarWidth}px)`,
            },
          }),
          ...(!customizer.isCollapse && {
            [theme.breakpoints.up('lg')]: { 
              width: `calc(100% - ${customizer.SidebarWidth}px)`,
            },
          }),
        }}
      >
        {/* Header */}
        {customizer.isHorizontal ? <HorizontalHeader /> : <Header />}
        
        {/* Navigation (for horizontal layout) */}
        {customizer.isHorizontal ? <Navigation /> : ''}
        
        {/* Main Content */}
        <Container
          sx={{
            maxWidth: customizer.isLayout === 'boxed' ? '1600px !important' : '100%',
            px: { xs: 2, sm: 2 },
            width: '100%',
          }}
        >
          <Box 
            sx={{
              minHeight: 'calc(100vh - 170px)',
              width: '100%',
              overflowX: 'auto',
              ...(customizer.isLayout === 'boxed' && {
                maxWidth: '1600px',
                mx: 'auto',
              }),
            }}
          >
            <Outlet />
          </Box>
        </Container>
        
        <Customizer />
      </PageWrapper>
    </MainWrapper>
  );
};

export default FullLayout;